import React, { Component } from 'react';
// import SnackbarProvider from 'react-simple-snackbar';

export default class SnackBar extends Component {
  static propTypes = {};

  render() {
    return (
      <div className="common-snack-bar">
        {/* <SnackbarProvider>
          <div>hello</div>
        </SnackbarProvider> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/SnackBar.js